<template>
  <!-- Main -->
  <div id="main" v-if="initialized">
    <!-- 時間 -->
    <div id="mainTime">
      <div class="areaH">
        <!-- <div class="areaV">
          <div class="box" style="justify-content: start;">
            <div class="item">
              <span class="title">供餐時段</span>
              <a class="add" @click="addTimePickerObj()"
                ><FontAwesomeIcon icon="plus"
              /></a>
            </div>
            <EditBoxRangeSelect
              v-for="(timePickerObj, index) in timePickerObjArr"
              :code="'time_obj_sectors'"
              :name="'點餐時段'"
              :dbTable="'business'"
              :key="'time_obj_sectors' + index"
              :value="timePickerObj"
              @update-time-picker="updateTimePicker($event, index)"
              @delete-time-picker="deleteTimePicker($event, index)"
            />
          </div>
        </div> -->

        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t("AccountSettingTime.Preparation_Time") }}</span>
            <EditBoxInputTime
              :code="'eat_in_waiting_time'"
              :name="$t('AccountSettingTime.Dine_In_Preparation_Time')"
              :dbTable="'business'"
              :key="'eat_in_waiting_time'"
              :unit="this.$t('AccountSettingTime.Minutes')"
              v-model="data.eat_in_waiting_time"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInputTime
              :code="'to_go_waiting_time'"
              :name="$t('AccountSettingTime.Takeout_Preparation_Time')"
              :dbTable="'business'"
              :key="'to_go_waiting_time'"
              :unit="this.$t('AccountSettingTime.Minutes')"
              v-model="data.to_go_waiting_time"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInputTime
              :code="'delivery_waiting_time'"
              :name="$t('AccountSettingTime.Delivery_Preparation_Time')"
              :dbTable="'business'"
              :key="'delivery_waiting_time'"
              :unit="this.$t('AccountSettingTime.Minutes')"
              v-model="data.delivery_waiting_time"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">{{ $t('AccountSettingTime.Default_Service_Period') }}</span>
              <a class="add" @click="addOpening('general')"
                ><FontAwesomeIcon icon="plus"
              /></a>
              <span class="remark">{{ $t('AccountSettingTime.Message.Click_to_Add') }}</span>
            </div>
            <table>
              <tr v-if="newOpening['general'] && newOpening['general'].length">
                <th><span class="content">{{ $t('AccountSettingTime.Business_Week') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Service_Period') }}</span></th>
                <th></th>
              </tr>
              <tr
                v-for="(schedule, index) in newOpening['general']"
                v-bind:key="schedule.id"
                :class="schedule.status"
              >
                <td align="center">
                  <div v-if="schedule.status === 'edit'" :class="['week edit']">
                    <a
                      :class="['content', { off: !day.status }]"
                      v-for="day of schedule.daysBitArray"
                      @click="toggleOpening(day)"
                      >{{ day.display }}</a
                    >
                  </div>
                  <div v-else :class="['week edit']">
                    <a
                      :class="['content', { off: !day.status }]"
                      v-for="day of schedule.daysBitArray"
                      >{{ day.display }}</a
                    >
                  </div>
                </td>
                <td align="center">
                  <div class="timeRange">
                    <select
                      name="time"
                      v-model="schedule.openHour"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <!-- <option value="allOpen">24 小時</option> -->
                      <option
                        v-for="option of timeHours"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                    <span class="content"
                      >:</span
                    >
                    <select
                      name="time"
                      v-model="schedule.openMinute"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <!-- <option value="allOpen">24 小時</option> -->
                      <option
                        v-for="option of timeMinutes"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                    <!-- <span class="content" v-if="schedule.openTime !== 'allOpen'"
                      >-</span
                    > -->
                    <span class="content"
                      >-</span
                    >
                    <select
                      name="time"
                      v-model="schedule.closeHour"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <option
                        v-for="option of timeHours"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                      <span class="content"
                      >:</span
                    >
                    <select
                      name="time"
                      v-model="schedule.closeMinute"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <option
                        v-for="option of timeMinutes"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="saveNewOpening('general', index)"
                      ><FontAwesomeIcon icon="save"
                    /></a>
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="removeNewOpening('general', index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="discardEdit('general', index)"
                      ><FontAwesomeIcon icon="times"
                    /></a>
                    <a
                      v-if="schedule.status !== 'edit'"
                      @click="startEditNewOpen('general', index)"
                      ><FontAwesomeIcon icon="pen"
                    /></a>
                    <a
                      v-if="schedule.status !== 'edit'"
                      @click="startEditNewOpen('general', index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="box" v-for="(mealType, index) in customTimes">
            <div class="item">
              <span class="title">{{ $t('AccountSettingTime.Service_Time_Coming_Soon', {mealType: mealType.display }) }}</span>
              <a class="add" @click="addOpening(mealType.key)"
                ><FontAwesomeIcon icon="plus"
              /></a>
              <span class="remark">{{ $t('AccountSettingTime.Click_Add_to_Add_Business_Day_and_Service_Period', {mealType: mealType.display }) }}</span>
            </div>
            <div class="tabs">
              <a :class="['tab', (mealType.useDefault ? 'active' : '')]" @click="updateMealTypeTimes(mealType, true)">
                <span>{{ $t('AccountSettingTime.Same_As_Default_Service_Period') }}</span>
              </a>
              <a :class="['tab', (mealType.useDefault ? '' : 'active')]" @click="updateMealTypeTimes(mealType, false)">
                <span>{{ $t('AccountSettingTime.Custom_Period') }}</span>
              </a>
            </div>
           <table v-if="!mealType.useDefault">
              <tr v-if="newOpening[mealType.key] && newOpening[mealType.key].length">
                <th><span class="content">{{ $t('AccountSettingTime.Business_Week') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Service_Period') }}</span></th>
                <th></th>
              </tr>
              <tr
                v-for="(schedule, index) in newOpening[mealType.key]"
                v-bind:key="schedule.id"
                :class="schedule.status"
              >
                <td align="center">
                  <div v-if="schedule.status === 'edit'" :class="['week edit']">
                    <a
                      :class="['content', { off: !day.status }]"
                      v-for="day of schedule.daysBitArray"
                      @click="toggleOpening(day)"
                      >{{ day.display }}</a
                    >
                  </div>
                  <div v-else :class="['week edit']">
                    <a
                      :class="['content', { off: !day.status }]"
                      v-for="day of schedule.daysBitArray"
                      >{{ day.display }}</a
                    >
                  </div>
                </td>
                <td align="center">
                  <div class="timeRange">
                    <select
                      name="time"
                      v-model="schedule.openHour"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <!-- <option value="allOpen">24 小時</option> -->
                      <option
                        v-for="option of timeHours"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                    <span class="content"
                      >:</span
                    >
                    <select
                      name="time"
                      v-model="schedule.openMinute"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <!-- <option value="allOpen">24 小時</option> -->
                      <option
                        v-for="option of timeMinutes"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                    <!-- <span class="content" v-if="schedule.openTime !== 'allOpen'"
                      >-</span
                    > -->
                    <span class="content"
                      >-</span
                    >
                    <select
                      name="time"
                      v-model="schedule.closeHour"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <option
                        v-for="option of timeHours"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                      <span class="content"
                      >:</span
                    >
                    <select
                      name="time"
                      v-model="schedule.closeMinute"
                      :disabled="schedule.status !== 'edit'"
                    >
                      <option
                        v-for="option of timeMinutes"
                        :value="option.id"
                        :key="option.id"
                        >{{ option.name }}</option
                      >
                    </select>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="saveNewOpening(mealType.key, index)"
                      ><FontAwesomeIcon icon="save"
                    /></a>
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="removeNewOpening(mealType.key, index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                    <a
                      v-if="schedule.status == 'edit'"
                      @click="discardEdit(mealType.key, index)"
                      ><FontAwesomeIcon icon="times"
                    /></a>
                    <a
                      v-if="schedule.status !== 'edit'"
                      @click="startEditNewOpen(mealType.key, index)"
                      ><FontAwesomeIcon icon="pen"
                    /></a>
                    <a
                      v-if="schedule.status !== 'edit'"
                      @click="startEditNewOpen(mealType.key, index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          
        </div>

        <!-- 營業時間 -->
        <!-- <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">供餐時間 </span>
              <a class="save" v-show="openingIsChanged" @click="saveOpening()"
                ><font-awesome-icon icon="save"
              /></a>
              <span class="remark" style="margin-top: -5px;"
                >設定每週供餐時間</span
              >
            </div>

            <div class="item" v-for="day of weekDays" v-bind:key="day.id">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="openingSetting[day.id].isOpen"
                />
                <span class="slider round"></span>
              </label>
              <div
                style="display: flex; flex-direction: column; align-items: center;"
              >
                <span class="content">{{ day.name }}</span>
                <span
                  :class="[
                    'remark',
                    openingSetting[day.id].isOpen ? '' : 'gray'
                  ]"
                  style="margin-top: -5px;"
                  >{{
                    openingSetting[day.id].isOpen === false ? "公休" : "營業"
                  }}</span
                >
              </div>

              <div
                class="timeRange"
                style="margin-left: 10px;"
                v-for="(hour, index) in openingSetting[day.id].hours"
                :key="index"
              >
                <select name="time" v-model="hour.openTime" disabled>
                  <option
                    v-if="openingSetting[day.id].isOpen"
                    value="allOpen"
                    label="24 小時"
                  ></option>
                  <option
                    v-if="openingSetting[day.id].isOpen"
                    v-for="option of timeOptions"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </select>
                <span
                  class="content"
                  v-if="
                    openingSetting[day.id].isOpen && hour.openTime !== 'allOpen'
                  "
                  >-</span
                >
                <select
                  name="time"
                  v-model="hour.closeTime"
                  v-if="
                    openingSetting[day.id].isOpen && hour.openTime !== 'allOpen'
                  "
                  disabled
                >
                  <option
                    v-for="option of timeOptions"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </select>
                <a class="delete" @click="deleteHour(day.id, index, hour)"
                  ><FontAwesomeIcon icon="trash"
                /></a>
              </div>

              <a class="add" @click="addHour(day.id)"
                ><FontAwesomeIcon icon="plus"
              /></a>
            </div>
          </div>
        </div> -->

        <!-- <div class="areaV">
          <div class="box" style="justify-content: start;">
            <span class="title">營業時間</span>
            <div class="chart-area">
              <canvas id="openingTimeChart"></canvas>
            </div>
            <div class="tableLabel item">
              <div class="color"></div>
              <span class="content">營業時間</span>
              <div class="color color2"></div>
              <span class="content">外送取餐時間</span>
              <div class="color"></div>
              <span class="content">自取取餐時間</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- 營業時間 -->
      <!-- <div class="areaH">
        
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">供餐時間 </span>
              <a class="save" v-show="openingIsChanged" @click="saveOpening()"
                ><font-awesome-icon icon="save"
              /></a>
            </div>

            <div class="item" v-for="day of weekDays" v-bind:key="day.id">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="openingSetting[day.id].isOpen"
                />
                <span class="slider round"></span>
              </label>
              <div
                style="display: flex; flex-direction: column; align-items: center;"
              >
                <span class="content">{{ day.name }}</span>
                <span
                  :class="[
                    'remark',
                    openingSetting[day.id].isOpen ? '' : 'gray'
                  ]"
                  style="margin-top: -5px;"
                  >{{
                    openingSetting[day.id].isOpen === false ? "公休" : "營業"
                  }}</span
                >
              </div>

              <div
                class="timeRange"
                style="margin-left: 10px;"
                v-for="(hour, index) in openingSetting[day.id].hours"
                :key="index"
              >
                <select name="time" v-model="hour.openTime">
                  <option
                    v-if="openingSetting[day.id].isOpen"
                    value="allOpen"
                    label="24 小時"
                  ></option>
                  <option
                    v-if="openingSetting[day.id].isOpen"
                    v-for="option of timeOptions"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </select>
                <span
                  class="content"
                  v-if="
                    openingSetting[day.id].isOpen && hour.openTime !== 'allOpen'
                  "
                  >-</span
                >
                <select
                  name="time"
                  v-model="hour.closeTime"
                  v-if="
                    openingSetting[day.id].isOpen && hour.openTime !== 'allOpen'
                  "
                >
                  <option
                    v-for="option of timeOptions"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </select>
                <a class="delete" @click="deleteHour(day.id, index, hour)"
                  ><FontAwesomeIcon icon="trash"
                /></a>
              </div>

              <a class="add" @click="addHour(day.id)"
                ><FontAwesomeIcon icon="plus"
              /></a>
            </div>
          </div>
        </div>
      </div> -->
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingTime.Days_Off') }}</span>
            <div style="margin-bottom: 10px;">
              <div style="display: flex; align-items: center;">
                <span class="content">{{ $t('AccountSettingTime.Directly_Add_Manually') }}</span>
                <div class="dateRange">
                  <input type="date" v-model="specialDateInput" />
                </div>
                <a class="add" @click="addSpecialDate()"
                  ><FontAwesomeIcon icon="plus"
                /></a>
              </div>
              <span class="remark"
                >{{ $t('AccountSettingTime.Message.Click_to_Select') }}</span
              >
            </div>
            <div style="margin-bottom: 10px;">
              <div style="display: flex; align-items: center;">
                <span class="content">{{ $t('AccountSettingTime.Batch_Addition') }}</span>
                <a class="textButton" @click="openImportPage()"
                  ><span>{{ $t('AccountSettingTime.Batch_Import_Specific_Days_Off') }}</span></a
                >
              </div>
              <span class="remark"
                >{{ $t('AccountSettingTime.Message.Import_Holidays') }}<br />
                {{ $t('AccountSettingTime.Message.Delete_Special_Days') }}</span
              >
            </div>
            <div class="item">
              <div
                class="date"
                v-for="day of specialOpeningData"
                v-bind:key="day.id"
                style="margin-right: 10px;"
              >
                <span class="content"
                  >{{ day.specialDate }}<br />{{ day.dayOfWeek }}</span
                >
                <a class="delete" @click="deleteSpecialDate(day.id)"
                  ><FontAwesomeIcon icon="trash"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="areaH">
        <div class="areaV">
            <div class="box">
              <span class="title">公休日</span>
              <div style="margin-bottom: 10px;">
                <div style="display: flex; align-items: center;">
                  <span class="content">直接手動新增</span>
                  <div class="dateRange">
                    <input type="date" v-model="specialDateInput">
                  </div>
                  <a class="add" @click="addSpecialDate()"
                ><FontAwesomeIcon icon="plus"
              /></a>
                </div>
                <span class="remark"
                  >點擊＋直接選擇日期，確認下方是否成功新增</span
                >
              </div>
              <div style="margin-bottom: 10px;">
                <div style="display: flex; align-items: center;">
                  <span class="content">批次新增</span>
                  <a class="textButton" @click="openImportPage()"><span>批次匯入特定公休日</span></a>
                </div>
                <span class="remark"
                  >透過匯入特殊公休日（例如國定假日）即可進行設定，每次匯入會重新覆蓋上次設定。<br />
                  要刪除特殊公休日，可將公休日從excel移除後，再次匯入即可。</span
                >
              </div>
              <div class="item">
                <div class="date" v-for="day of specialOpeningData" v-bind:key="day.id" style="margin-right: 10px;">
                  <span class="content">{{day.specialDate}}<br />{{day.dayOfWeek}}</span>
                  <a class="delete" @click="deleteSpecialDate(day.id)"
                  ><FontAwesomeIcon icon="trash"
                /></a>
                </div>
              </div>
            </div>
          </div>
      </div> -->

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingTime.Reservation_Days_Ahead') }}</span>
            <div class="item">
              <EditBoxSelect
                :code="'time_sector_days'"
                :name="$t('AccountSettingTime.Reservation_Days_Ahead')"
                :dbTable="'business'"
                :key="'time_sector_days'"
                :value="data.time_sector_days"
                :options="reserveOptions"
                @update-select="updateSelect($event)"
                @change-edit-status="changeEditStatus($event)"
              />
            </div>
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingTime.Time_Slot_Interval') }}</span>
            <EditBoxInputTime
              :code="'time_sector_length'"
              :name="$t('AccountSettingTime.Time_Slot_Interval')"
              :dbTable="'business'"
              :key="'time_sector_length'"
              v-model="data.time_sector_length"
              @update-input="updateInput($event)"
              hideName
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">{{ $t('AccountSettingTime.Limit_Flow_Setting') }}</span>
              <a class="add" @click="addOrderLimitSetting()"
                ><FontAwesomeIcon icon="plus"
              /></a>
            </div>
            <table>
              <tr>
                <th><span class="content">{{ $t('AccountSettingTime.Pickup_Method') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Business_Hours') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Flow_Control_Period') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Interval_Period') }}</span></th>
                <th><span class="content">{{ $t('AccountSettingTime.Order_Limit_Per_Period') }}</span></th>
                <th></th>
              </tr>
              <tr class="edit" v-show="newOrderLimitSetting.display">
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="newOrderLimitSetting.mealType">
                      <option
                        v-for="(mealTypeOption, index) in mealTypeOptions"
                        :key="'mealType' + index"
                        :value="mealTypeOption.value"
                        >{{ mealTypeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="week edit">
                    <a
                      v-for="(periodSession, index) in newOrderLimitSetting.periodSession"
                      :key="'periodSession' + index"
                      :class="{ content: true, off: !periodSession.selected }"
                      @click="editNewPeriodSession(periodSession)"
                      >{{ displayDayOfWeekByNumber(periodSession.value) }}</a
                    >
                  </div>
                </td>
                <td align="center">
                  <el-row>
                    <el-col :span="22">
                      <el-time-picker
                        is-range
                        v-model="orderLimitTimePicker"
                        range-separator="—"
                        :start-placeholder="$t('AccountSettingTime.Start_Time')"
                        :end-placeholder="$t('AccountSettingTime.End_Time')"
                        :picker-options="timePickerOptions"
                        value-format="HH:mm"
                        size="mini"
                        :clearable="false"
                        @change="orderLimitTimePickerChange($event)"
                      >
                      </el-time-picker>
                    </el-col>
                  </el-row>
                </td>
                <td align="center">
                  <div class="number" style="width: 100px;">
                    <div class="dropdown">
                      <select
                        name="type"
                        v-model="newOrderLimitSetting.sessionTime"
                      >
                        <option
                          v-for="(sessionTime,
                          sessionTimeIndex) in sessionTimeOptions"
                          :key="'newSessionTime' + sessionTimeIndex"
                          :value="sessionTime.value"
                          >{{ sessionTime.label }}</option
                        >
                      </select>
                      <div class="arrow">
                        <FontAwesomeIcon icon="caret-down" />
                      </div>
                    </div>
                    <span class="content unit">{{ $t('AccountSettingTime.Minutes') }}</span>
                  </div>
                </td>
                <td align="center">
                  <div class="number" style="width: 100px;">
                    <input
                      type="number"
                      v-model="newOrderLimitSetting.maxNumOfOrder"
                      min="0"
                    />
                    <span class="content unit">{{ $t('AccountSettingTime.Orders') }}</span>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a @click="saveOrderLimitSetting()"
                      ><FontAwesomeIcon icon="save"
                    /></a>
                    <a @click="dropNewOrderLimitSetting()"
                      ><FontAwesomeIcon icon="times"
                    /></a>
                  </div>
                </td>
              </tr>
              <tr
                :class="{ edit: orderLimit.editMode }"
                v-for="(orderLimit, index) in orderLimitSettings"
                :key="'orderLimit' + index"
                :ref="'orderLimitSetting' + index"
              >
                <td align="center">
                  <span class="content" v-if="!orderLimit.editMode">{{
                    displayMealType(orderLimit.mealType)
                  }}</span>
                  <div class="dropdown" v-else>
                    <select name="type" v-model="orderLimit.mealType">
                      <option
                        v-for="(mealTypeOption, _index) in mealTypeOptions"
                        :key="'mealType' + index + _index"
                        :value="mealTypeOption.value"
                        >{{ mealTypeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="week edit">
                    <div
                      v-for="(periodSession, periodSessionIndex) in orderLimit.periodSession"
                      :key="'periodSession' + index + periodSessionIndex"
                      :class="{ content: true, off: !periodSession.selected }"
                      @click="
                        editPeriodSession(
                          periodSession,
                          index,
                          periodSessionIndex
                        )
                      "
                    >
                      {{ displayDayOfWeekByNumber(periodSession.value) }}
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span v-if="!orderLimit.editMode" class="content">{{
                    displayTimeSession(orderLimit.timeSession)
                  }}</span>
                  <el-row v-else>
                    <el-col :span="22">
                      <el-time-picker
                        is-range
                        v-model="editTimeSessionValue"
                        range-separator="—"
                        :start-placeholder="$t('AccountSettingTime.Start_Time')"
                        :end-placeholder="$t('AccountSettingTime.End_Time')"
                        :picker-options="timePickerOptions"
                        value-format="HH:mm"
                        size="mini"
                        :clearable="false"
                        :key="'editModeTimePicker' + index"
                        @change="editOrderLimitTimePickerChange($event, index)"
                      >
                      </el-time-picker>
                    </el-col>
                  </el-row>
                </td>
                <td align="center">
                  <span v-if="!orderLimit.editMode" class="content"
                    >{{ `${orderLimit.sessionTime} ${$t('AccountSettingTime.Minutes')}` }}</span
                  >
                  <div class="dropdown" v-else>
                    <select name="type" v-model="orderLimit.sessionTime">
                      <option
                        v-for="(sessionTime,
                        sessionTimeIndex) in sessionTimeOptions"
                        :key="'sessionTime' + index + sessionTimeIndex"
                        :value="sessionTime.value"
                        >{{ sessionTime.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span v-if="!orderLimit.editMode" class="content"
                    >{{ `${orderLimit.maxNumOfOrder} ${$t('AccountSettingTime.Orders')}` }}</span
                  >
                  <div v-else class="number" style="width: 100px;">
                    <input
                      type="number"
                      v-model="orderLimit.maxNumOfOrder"
                      min="0"
                    />
                    <span class="content unit">{{ $t('AccountSettingTime.Orders') }}</span>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a
                      v-if="!orderLimit.editMode"
                      @click="editOrderLimitSetting(index)"
                      ><FontAwesomeIcon icon="pen"
                    /></a>
                    <a v-else @click="saveEditOrderLimit(index)"
                      ><FontAwesomeIcon icon="save"
                    /></a>
                    <a
                      v-if="!orderLimit.editMode"
                      @click="deleteOrderLimit(index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                    <a v-else @click="abandonEditOrderLimit(index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EditBoxInputTime from "src/components/GaaConsole/EditBoxInputTime.vue";
import EditBoxSelect from "src/components/GaaConsole/EditBoxSelect.vue";
import EditBoxRangeSelect from "src/components/GaaConsole/EditBoxRangeSelect.vue";
import EditBoxBoolean from "src/components/GaaConsole/EditBoxBoolean.vue";

import MD5 from "src/util/md5";
// import Chart from "chart.js";
// import BarChart from 'src/components/Charts/BarChart';
import { timeChart } from "@/components/Charts/TimeChart";

import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo
} from "src/javascripts/generalPages/updateForConsoleLog";
import {
  fetchSettings,
  fetchOrderLimits
} from "src/javascripts/generalPages/fetchForConsoleLog";
import { insertOrderLimits } from "src/javascripts/generalPages/postForConsoleLog";
import { updateOrderLimits } from "src/javascripts/generalPages/updateForConsoleLog";
import { deleteOrderLimits } from "src/javascripts/generalPages/deleteForConsoleLog";

export default {
  components: {
    FontAwesomeIcon,
    EditBoxInputTime,
    EditBoxSelect,
    EditBoxRangeSelect,
    EditBoxBoolean
  },
  data() {
    return {
      data: {
        eat_in_waiting_time: 1,
        to_go_waiting_time: 1,
        delivery_waiting_time: 1,
        time_sector_days: 1,
        time_sector_length: 1,
        time_obj_sectors: JSON.stringify([{ start: "00:00", end: "23:59" }]),

        meal_types: "delivery"
      },
      initialized: false,
      // reserveOptions: [
      //   {
      //     value: 0,
      //     label: "限立即點餐"
      //   }
      // ],
      dialogFormVisible: false,
      timePickerOptions: {
        format: "HH:mm"
      },
      timePickerDefaultObj: { start: "00:00", end: "23:59" },
      timePickerObjArr: [],
      originTimePickerObjArr: [],
      // mealTypeOptions: [
      //   {
      //     value: "delivery",
      //     label: "外送"
      //   },
      //   {
      //     value: "to_go",
      //     label: "自取"
      //   },
      //   {
      //     value: "eat_in",
      //     label: "內用"
      //   }
      // ],
      newOrderLimitSetting: {
        display: false,
        mealType: "eat_in",
        periodSession: [
          {
            value: 1,
            selected: true
          },
          {
            value: 2,
            selected: true
          },
          {
            value: 3,
            selected: true
          },
          {
            value: 4,
            selected: true
          },
          {
            value: 5,
            selected: true
          },
          {
            value: 6,
            selected: true
          },
          {
            value: 0,
            selected: true
          }
        ],
        timeSession: { start: "00:00", end: "23:59" },
        sessionTime: 15,
        maxNumOfOrder: 5,
        reset: function() {
          this.display = false;
          this.mealType = "eat_in";
          this.periodSession = [
            {
              value: 1,
              selected: true
            },
            {
              value: 2,
              selected: true
            },
            {
              value: 3,
              selected: true
            },
            {
              value: 4,
              selected: true
            },
            {
              value: 5,
              selected: true
            },
            {
              value: 6,
              selected: true
            },
            {
              value: 0,
              selected: true
            }
          ];
          this.timeSession = { start: "00:00", end: "23:59" };
          this.sessionTime = 15;
          this.maxNumOfOrder = 5;
          return;
        }
      },
      orderLimitTimePicker: ["00:00", "23:59"],
      orderLimitSettings: [
        {
          id: 1,
          display: false,
          mealType: "eat_in",
          periodSession: [
            {
              value: 1,
              selected: false
            },
            {
              value: 2,
              selected: false
            },
            {
              value: 3,
              selected: true
            },
            {
              value: 4,
              selected: false
            },
            {
              value: 5,
              selected: false
            },
            {
              value: 6,
              selected: false
            },
            {
              value: 0,
              selected: false
            }
          ],
          timeSession: { start: "09:00", end: "12:00" },
          sessionTime: 15,
          maxNumOfOrder: 5
        },
        {
          id: 2,
          display: false,
          mealType: "to_go",
          periodSession: [
            {
              value: 1,
              selected: false
            },
            {
              value: 2,
              selected: false
            },
            {
              value: 3,
              selected: true
            },
            {
              value: 4,
              selected: false
            },
            {
              value: 5,
              selected: false
            },
            {
              value: 6,
              selected: false
            },
            {
              value: 0,
              selected: false
            }
          ],
          timeSession: { start: "08:00", end: "22:00" },
          sessionTime: 15,
          maxNumOfOrder: 5
        }
      ],
      editTimeSessionValue: ["00:00", "23:00"],
      sessionTimeOptions: [
        {
          value: 15,
          label: 15
        },
        {
          value: 30,
          label: 30
        },
        {
          value: 60,
          label: 60
        }
      ],
      tempOrderLimitSetting: {},
      editList: [],
      openingSetting: {
        "general": {
          //營業時間相關
          "0": {},
          "1": {},
          "2": {},
          "3": {},
          "4": {},
          "5": {},
          "6": {}
        },
        togo: {
          //營業時間相關
          "0": {},
          "1": {},
          "2": {},
          "3": {},
          "4": {},
          "5": {},
          "6": {}
        },
        delivery: {
          //營業時間相關
          "0": {},
          "1": {},
          "2": {},
          "3": {},
          "4": {},
          "5": {},
          "6": {}
        }
        
      },
      newOpening: {
        general: [],
        togo: false,
        delivery: false
      },
      // weekDays: [
      //   //營業時間相關
      //   { id: "0", name: "星期日" },
      //   { id: "1", name: "星期一" },
      //   { id: "2", name: "星期二" },
      //   { id: "3", name: "星期三" },
      //   { id: "4", name: "星期四" },
      //   { id: "5", name: "星期五" },
      //   { id: "6", name: "星期六" }
      // ],
      openingChartOptions: { // for chart.js v2
        events: [],
        legend: {
          display: false
        },
        tooltips: {enabled: false},
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            ticks: {
              stacked: true,
              reverse: true,
              min: 0,
              max: 24, 
              stepSize: 2
            }
          }]
        }
      },
      specialOpeningData: [],
      currentOpeningDigest: "",
      openingIsChanged: false,
      specialDateInput: "",
      // customTimes: [{"key": "togo", "display": "自取", "useDefault": true}, {"key": "delivery", "display": "外送", "useDefault": true}]
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    }
  }, 
  mounted() {
    // let self = this;
    // setTimeout(function() {
    //   // timeChart.createChart("openingTimeChart");
    //   timeChart.createChart('openingTimeChart', self.openingChartData, self.openingChartOptions);
    // }, 1000);
  },
  created: function() {
    // fetch value
    console.log("created!!");
    fetchSettings(this.accountId, this.$route.params.type)
      .then(fetchSettingsRes => {
        if (fetchSettingsRes.data.length > 0) {
          return Promise.all([
            fetchOrderLimits(this.accountId, this.$route.params.type),
            fetchSettingsRes.data[0]
          ]);
        } else {
          throw new Error("FetchData error!");
        }
      })
      .then(fetchOrderLimitsRes => {
        this.setData(fetchOrderLimitsRes);
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: this.$t("AccountSettingTime.Error_Retrieving_Data_For_Store_AccountId", {accountId: this.accountId})
        });
      });

    // initailize reserveOptions data
    for (let index = 1; index <= 30; index++) {
      this.reserveOptions.push({
        value: index,
        label: this.$t("AccountSettingTime.Can_Booking_Days", {index})
      });
    }
    console.log("reserveOptions: ", this.reserveOptions);

    // initialize new order limit
    this.orderLimitTimePicker = this.convertToTimePickerFormat(
      this.newOrderLimitSetting.timeSession
    );

    // 設定可選營業時間
    this.initTimeOptions();
    // 設定預設營業時間, 全日開
    this.initOpeningSetting();
    this.getSpecialOpenings();
  },
  computed: {
    daysBitArray() {
      return [
          { status: false, display: this.$t("AccountSettingTime.Sun"), id: "0", openDay: 0, closeDay: 1 }, // sunday
          { status: false, display: this.$t("AccountSettingTime.Mon"), id: "1", openDay: 1, closeDay: 2 },
          { status: false, display: this.$t("AccountSettingTime.Tue"), id: "2", openDay: 2, closeDay: 3 },
          { status: false, display: this.$t("AccountSettingTime.Wed"), id: "3", openDay: 3, closeDay: 4 },
          { status: false, display: this.$t("AccountSettingTime.Thu"), id: "4", openDay: 4, closeDay: 5 },
          { status: false, display: this.$t("AccountSettingTime.Fri"), id: "5", openDay: 5, closeDay: 6 },
          { status: false, display: this.$t("AccountSettingTime.Sat"), id: "6", openDay: 6, closeDay: 0 }
        ]
    },
    reserveOptions() {
      return [
        {
          value: 0,
          label: this.$t("AccountSettingTime.Limit_Immediate_Order")
        }
      ]
    },
    weekDays() {
      return [
        //營業時間相關
        { id: "0", name: this.$t("AccountSettingTime.Sunday")},
        { id: "1", name: this.$t("AccountSettingTime.Monday")},
        { id: "2", name: this.$t("AccountSettingTime.Tuesday")},
        { id: "3", name: this.$t("AccountSettingTime.Wednesday")},
        { id: "4", name: this.$t("AccountSettingTime.Thursday")},
        { id: "5", name: this.$t("AccountSettingTime.Friday")},
        { id: "6", name: this.$t("AccountSettingTime.Saturday")}
      ]
    },
    customTimes () {
      return [];
      // 暫時移除自取/外送供餐時間(即將上線) UI 
      // return [
      //   {"key": "togo", "display": this.$t("AccountSettingTime.Self_Pickup"), "useDefault": true}, 
      //   {"key": "delivery", "display": this.$t("AccountSettingTime.Delivery"), "useDefault": true}]
    },
    mealTypeOptions() {
      return [
        {
          value: "delivery",
          label: this.$t("AccountSettingTime.Delivery")
        },
        {
          value: "to_go",
          label: this.$t("AccountSettingTime.Self_Pickup")
        },
        {
          value: "eat_in",
          label: this.$t("AccountSettingTime.Dine_In")
        }
      ]
    },
    // openingChartData: function() {
    //   var c1 = "#F96332";
    //   var c2 = "#A0D468";
    //   var c3 = "#5D9CEC";
    //   // 還要區分取餐方式
    //   // let tmp = [];
    //   // 先解決其他重要問題，最後再來解這個
    //   // let tmpChart = [];
    //   // let maxScheduleNum = 0;

    //   // let previousEnd = [0, 0, 0, 0, 0, 0, 0];
    //   // for (let schedule of this.newOpening['general']) {
    //   //   console.log('the s ' + JSON.stringify(schedule));
    //   //   let start, end;
    //   //   if (schedule.openTime === 'allOpen') {
    //   //     start = 0;
    //   //     end = 24;
    //   //   } else {
    //   //     start = parseInt(schedule.openTime, 10) / 100;
    //   //     end = parseInt(schedule.closeTime, 10) / 100;
    //   //     console.log('start gogo ' + start);
    //   //   }

    //   //   if (start === end) {
    //   //     if (schedule.openDay === schedule.closeDay) {
    //   //       start = 0;
    //   //       end = 0;
    //   //     } else {
    //   //       start = 0;
    //   //       end = 24;
    //   //     }
    //   //   }
    //   //   let timeArray = [];
    //   //   for (let i = 0; i < 7; ++i) {
    //   //     let bs, be;
    //   //     if (start > previousEnd[i])
    //   //       bs = start - previousEnd[i];
    //   //     else
    //   //       bs = 0;

    //   //     if (end > previousEnd[i]) 
    //   //       be = end - previousEnd[i];
    //   //     else
    //   //       be = 0;

    //   //     if (schedule.daysBitArray[i] && schedule.daysBitArray[i].status) {
    //   //       timeArray.push([bs, be]);
    //   //     }
    //   //     else {
    //   //       console.log('the i is ' + i);
    //   //       console.log('push ' , [previousEnd[i], previousEnd[i]]);
    //   //       timeArray.push([previousEnd[i], previousEnd[i]]);
    //   //     }
    //   //     previousEnd[i] = be; 
    //   //   }
    //   //   tmp.push({
    //   //     label: '營業時間',
    //   //     data: timeArray,
    //   //     backgroundColor: [c1,c1,c1,c1,c1,c1,c1],
    //   //     stack: 'Stack 0', // 營業時間
    //   //     barPercentage: 0.5,
    //   //     borderRadius: Number.MAX_VALUE,
    //   //     borderSkipped: false,
    //   //   });
    //   // }
    //   // console.log('br data ' + JSON.stringify(tmp));
    //   // return {
    //   //   labels: ["日", "一", "二", "三", "四", "五", "六1"],
    //   //   datasets: tmp
    //   // }
      
    //   // for (let d in this.openingSetting) { // 這個好像不一定會照順序
    //   //   console.log('the d ' + JSON.stringify(d));
    //   //   console.log(JSON.stringify(this.openingSetting[d].hours));
        
    //   //   let dIndex = parseInt(d, 10);
    //   //   if (!this.openingSetting[d].hours) {
    //   //     tmpChart[dIndex] = null;
    //   //     continue;
    //   //   }

    //   //   if (!this.openingSetting[d].isOpen) {
    //   //     tmpChart[dIndex] = null;
    //   //     continue;
    //   //   }

    //   //   if (this.openingSetting[d].hours.length > maxScheduleNum) {
    //   //     maxScheduleNum = this.openingSetting[d].hours.length;
    //   //   }

    //   //   for (let i = 0; i < this.openingSetting[d].hours.length; ++i) { // 如果一day有多個schedule, 代表一天有多段營業時間
    //   //     let schedule = this.openingSetting[d].hours[i];
          
    //   //     let start, end;
    //   //     if (schedule.openTime === 'allOpen') {
    //   //       start = 0;
    //   //       end = 24;
    //   //     } else {
    //   //       start = parseInt(schedule.openTime, 10) / 100;
    //   //       end = parseInt(schedule.closeTime, 10) / 100;
    //   //       console.log('start gogo ' + start);

    //   //       if (start === end) {
    //   //         if (schedule.openDay === schedule.closeDay) {
    //   //           start = 0;
    //   //           end = 0;
    //   //         } else {
    //   //           start = 0;
    //   //           end = 24;
    //   //         }
    //   //       }
    //   //     }
    //   //     if (!tmpChart[dIndex]) {
    //   //       tmpChart[dIndex] = [];
    //   //     }
    //   //     tmpChart[dIndex][i] = [start, end];
    //   //   }       
    //   // }

    //   // for (let b = 0; b < maxScheduleNum; ++b) {
    //   //   let tmpArray = [];
    //   //   for (let dIndex = 0; dIndex < tmpChart.length; ++dIndex) {
    //   //     if (!tmpChart[dIndex]) {
    //   //       tmpArray.push([]);
    //   //     } else {
    //   //       if (tmpChart[dIndex] && tmpChart[dIndex][b]) {
    //   //         tmpArray.push(tmpChart[dIndex][b])
    //   //       } else {
    //   //         tmpArray.push([]);
    //   //       }
    //   //     }
    //   //   }
    //   //   tmp.push({
    //   //     label: '營業時間',
    //   //     data: tmpArray,
    //   //     backgroundColor: [c1,c1,c1,c1,c1,c1,c1],
    //   //     stack: 'Stack 0',
    //   //     barPercentage: 0.5,
    //   //     borderRadius: Number.MAX_VALUE,
    //   //     borderSkipped: false,
    //   //   });
    //   // }
    // },
    orderLimitEditMode: function() {
      let index = this.orderLimitSettings.findIndex(d => d.editMode == true);
      if (index == -1) {
        return false;
      } else {
        return true;
      }
    },
    user: function() {
      return this.$store.getters.user;
    },
    openingDigest: function() {
      return MD5(JSON.stringify(this.openingSetting));
    },
    type() {
      return this.$route.params.type || 'gaa';
    }
  },
  methods: {
    setData(fetchDataArr) {
      let orderLimitData = fetchDataArr[0].data;
      let fetchData = fetchDataArr[1];
      this.data = Object.assign(this.data, fetchData);
      this.convertToTimeObjArr();
      this.convertToPeriodSessionObjArr(orderLimitData);
      this.originTimePickerObjArr = this.timePickerObjArr;
      this.initialized = true;
    },
    updateInput(event) {
      let updateInputData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        origin: event.origin,
        label: event.name,
        type: event.type
      };
      this.edit(updateInputData);
    },
    edit(data) {
      let label = data.label;
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId, this.type)
            .then(res => updateBusiness(data, this.accountId, this.type))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        default:
          console.log("undefined db talbe: " + data.dbTable);
          break;
      }
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: `${label} 修改成功！`
      });
      this.$emit("saved", true);
      this.originTimePickerObjArr = this.timePickerObjArr;
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: "修改失敗"
      });
    },
    updateSelect(event) {
      let updateInputData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        origin: event.origin,
        label: event.name,
        type: event.type
      };
      this.edit(updateInputData);
    },
    addTimePickerObj() {
      this.timePickerObjArr.push(this.timePickerDefaultObj);
      let updateTimePickerData = {
        key: "time_obj_sectors",
        value: JSON.stringify(this.timePickerObjArr),
        dbTable: "business",
        origin: JSON.stringify(this.originTimePickerObjArr),
        label: this.$t("AccountSettingTime.Order_Time_Slots"),
        type: "object"
      };
      this.edit(updateTimePickerData);
    },
    removeTimePicker(index) {
      this.timePickerObjArr.splice(index, 1);
    },
    convertToTimeObjArr() {
      let timeObjSectors = this.data.time_obj_sectors;

      if (timeObjSectors) {
        this.timePickerObjArr = JSON.parse(timeObjSectors);
      } else {
        this.timePickerObjArr = [];
      }
    },
    convertToPeriodSessionObjArr(orderLimitData) {
      let formatedOrderLimitData = orderLimitData.map(d => {
        let periodSession = JSON.parse(d.periodSession);
        let formatedPeriodSession = [
          {
            value: 1,
            selected: false
          },
          {
            value: 2,
            selected: false
          },
          {
            value: 3,
            selected: false
          },
          {
            value: 4,
            selected: false
          },
          {
            value: 5,
            selected: false
          },
          {
            value: 6,
            selected: false
          },
          {
            value: 0,
            selected: false
          }
        ];
        formatedPeriodSession.forEach(p => {
          if (periodSession.includes(p.value)) p.selected = true;
        });
        return Object.assign({}, d, {
          periodSession: formatedPeriodSession,
          timeSession: JSON.parse(d.timeSession)
        });
      });
      this.orderLimitSettings = formatedOrderLimitData;
    },
    convertToPeriodSessionArr(periodSessionObjArr) {
      let filterPeriodSessionObjArr = periodSessionObjArr.filter(
        p => p.selected == true
      );
      return filterPeriodSessionObjArr.map(p => p.value);
    },
    updateTimePicker(event, index) {
      let value = event.mutation;
      this.timePickerObjArr.splice(index, 1, value);
      let updateTimePickerData = {
        key: event.code,
        value: JSON.stringify(this.timePickerObjArr),
        dbTable: event.dbTable,
        origin: JSON.stringify(this.originTimePickerObjArr),
        label: event.name,
        type: event.type
      };
      this.edit(updateTimePickerData);
    },
    deleteTimePicker(event, index) {
      this.removeTimePicker(index);

      let updateTimePickerData = {
        key: event.code,
        value: JSON.stringify(this.timePickerObjArr),
        dbTable: event.dbTable,
        origin: JSON.stringify(this.originTimePickerObjArr),
        label: event.name,
        type: event.type
      };
      this.edit(updateTimePickerData);
    },
    addOrderLimitSetting() {
      Object.assign(this.newOrderLimitSetting, {
        display: true
      });
    },
    displayDayOfWeekByNumber(number) {
      var displayDayOfWeek = "";
      switch (number) {
        case 1:
          displayDayOfWeek = "一";
          break;
        case 2:
          displayDayOfWeek = "二";

          break;
        case 3:
          displayDayOfWeek = "三";

          break;
        case 4:
          displayDayOfWeek = "四";

          break;
        case 5:
          displayDayOfWeek = "五";

          break;
        case 6:
          displayDayOfWeek = "六";

          break;
        case 0:
          displayDayOfWeek = "日";

          break;

        default:
          break;
      }
      return displayDayOfWeek;
    },
    convertToTimePickerFormat(timeSession) {
      return [timeSession.start, timeSession.end];
    },
    convertToTimeSessionFormat(timePickerValue) {
      return {
        start: timePickerValue[0],
        end: timePickerValue[1]
      };
    },
    orderLimitTimePickerChange(event) {
      this.newOrderLimitSetting.timeSession = this.convertToTimeSessionFormat(
        event
      );
      return;
    },
    editOrderLimitTimePickerChange(event, index) {
      let orderLimitSetting = this.orderLimitSettings[index];
      Object.assign(orderLimitSetting, {
        timeSession: this.convertToTimeSessionFormat(event)
      });
      this.orderLimitSettings.splice(index, 1, orderLimitSetting);
      return;
    },
    saveOrderLimitSetting() {
      let newSetting = JSON.parse(JSON.stringify(this.newOrderLimitSetting));
      let insertOrderLimitData = {
        orderLimitData: Object.assign(
          {},
          {
            account_id: this.accountId,
            meal_type: newSetting.mealType,
            period_session: JSON.stringify(
              this.convertToPeriodSessionArr(newSetting.periodSession)
            ),
            time_session: JSON.stringify(newSetting.timeSession),
            session_time: newSetting.sessionTime,
            max_num_of_order: newSetting.maxNumOfOrder
          }
        )
      };
      let that = this;
      insertOrderLimits(that.accountId, insertOrderLimitData, this.type)
        .then(insertOrderLimitsRes => {
          // update that.orderLimitSettings after inster into db
          that.orderLimitSettings.push(newSetting);
          let newIndex = that.orderLimitSettings.length - 1;
          // update that.orderLimitSettings last obj id
          let insertId = insertOrderLimitsRes.data.insertId;
          that.orderLimitSettings[newIndex].id = insertId;
          that.orderLimitSettings.splice(newIndex, 1, newSetting);
          that.newOrderLimitSetting.reset();
          that.$message({
            type: "success",
            message: "新增限流條件成功！"
          });
        })
        .catch(insertOrderLimitsErr => {
          console.log("insertOrderLimitsErr: ", insertOrderLimitsErr);
          that.$message({
            type: "error",
            message: "新增限流條件錯誤，請重新操作"
          });
          that.newOrderLimitSetting.reset();
        });
      return;
    },
    dropNewOrderLimitSetting() {
      this.newOrderLimitSetting.reset();
    },
    saveEditOrderLimit(index) {
      let orderLimitSetting = this.orderLimitSettings[index];
      let updateOrderLimitData = {
        orderLimitData: Object.assign(
          {},
          {
            id: orderLimitSetting.id,
            account_id: this.accountId,
            meal_type: orderLimitSetting.mealType,
            period_session: JSON.stringify(
              this.convertToPeriodSessionArr(orderLimitSetting.periodSession)
            ),
            time_session: JSON.stringify(orderLimitSetting.timeSession),
            session_time: orderLimitSetting.sessionTime,
            max_num_of_order: orderLimitSetting.maxNumOfOrder
          }
        )
      };
      let that = this;
      updateOrderLimits(
        that.accountId,
        updateOrderLimitData,
        orderLimitSetting.id, 
        this.type
      )
        .then(updateOrderLimitsRes => {
          if (updateOrderLimitsRes.data.affectedRows > 0) {
            that.$message({
              type: "success",
              message: "更新限流條件成功！"
            });
            Object.assign(orderLimitSetting, {
              editMode: false
            });
            this.orderLimitSettings.splice(index, 1, orderLimitSetting);
            console.log(this.orderLimitSettings);
          }
        })
        .catch(updateOrderLimitsErr => {
          console.log("updateOrderLimitsErr: ", updateOrderLimitsErr);
          that.$message({
            type: "error",
            message: "更新限流條件失敗，請重新操作"
          });
          that.abandonEditOrderLimit(index);
        });

      return;
    },
    editOrderLimitSetting(index) {
      let editModeIndex = this.orderLimitSettings.findIndex(
        orderLimitSetting => {
          return orderLimitSetting.editMode;
        }
      );
      if (editModeIndex != -1) {
        this.$message({
          type: "warning",
          message: "請先儲存編輯中的設定"
        });
        return;
      }
      let ref = this.$refs["orderLimitSetting" + index][0];
      let orderLimitSetting = this.orderLimitSettings[index];
      this.tempOrderLimitSetting = JSON.parse(
        JSON.stringify(Object.assign({}, orderLimitSetting))
      );
      Object.assign(orderLimitSetting, {
        editMode: true
      });
      this.editTimeSessionValue = this.convertToTimePickerFormat(
        orderLimitSetting.timeSession
      );
      this.orderLimitSettings.splice(index, 1, orderLimitSetting);
    },
    abandonEditOrderLimit(index) {
      Object.assign(this.tempOrderLimitSetting, {
        editMode: false
      });
      this.orderLimitSettings.splice(index, 1, this.tempOrderLimitSetting);
    },
    editNewPeriodSession(periodSession) {
      periodSession.selected = !periodSession.selected;
    },
    editPeriodSession(periodSession, index) {
      if (this.orderLimitSettings[index].editMode) {
        periodSession.selected = !periodSession.selected;
        console.log(this.orderLimitSettings[index]);
      }
    },
    displayMealType(mealType) {
      return mealType == "eat_in"
      ? this.$t("AccountSettingTime.Dine_In")
        : mealType == "to_go"
        ? this.$t("AccountSettingTime.Self_Pickup")
        : this.$t("AccountSettingTime.Delivery");
    },
    displayTimeSession(timeSession) {
      return `${timeSession.start}-${timeSession.end}`;
    },
    deleteOrderLimit(index) {
      let orderLimitSetting = this.orderLimitSettings[index];
      let that = this;
      deleteOrderLimits(this.accountId, orderLimitSetting.id, this.type)
        .then(deleteOrderLimitsRes => {
          that.orderLimitSettings.splice(index, 1);
          that.$message({
            type: "success",
            message: this.$t("AccountSettingTime.Successfully_Deleted_Flow_Control_Condition")
          });
        })
        .catch(deleteOrderLimitsErr => {
          console.log("deleteOrderLimitsErr: ", deleteOrderLimitsErr);
          that.$message({
            type: "error",
            message: this.$t("AccountSettingTime.Delete_Flow_Control_Condition_Failed_Please_Retry")
          });
        });
    },
    changeEditStatus(event) {
      console.log("changeEditStatus event: ", event);
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    },
    groupBy: function(list, props) {
      //公休日相關
      return list.reduce((a, b) => {
        (a[b[props]] = a[b[props]] || []).push(b);
        return a;
      }, {});
    },
    initOpeningSetting: function() {
      //公休日相關
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.accountId
          }/opening-hours`
        )
        .then(response => {
          // console.log("the response data " + JSON.stringify(response));
          let resData = response.data;

          let handles = ['general', 'togo', 'delivery'];
          // let handles = ['general'];
          for (let mealType of handles) {
            let general = resData[mealType] || [];
            // 先group by day
            // let dayGroup = self.groupBy(response.data, "openDay");
            
            let dayGroup = self.groupBy(general, "openDay");

            for (let i = 0; i < 7; ++i) {
              // 有存設定
              let thisDayGroups = dayGroup[i.toString()];
              if (thisDayGroups) {
                // 現在不判斷是否進階了，全都用進階寫法

                // 特殊設定版本
                // 不允許修改
                self.openingSetting[mealType][i.toString()] = {
                  isOpen: true,
                  hours: []
                };
                for (let j = 0; j < thisDayGroups.length; ++j) {
                  let thisDayGroup = thisDayGroups[j];
              
                  if (thisDayGroup.openDay === thisDayGroup.closeDay) {
                    // 同日
                    if (thisDayGroup.openTime === thisDayGroup.closeTime) {
                      // 同時又同日，跳過此設定
             
                      self.openingSetting[mealType][i.toString()].isOpen = false;
                      self.openingSetting[mealType][i.toString()].hours = [
                        {
                          openTime: thisDayGroup.closeTime,
                          closeTime: thisDayGroup.closeTime,
                          openHour:  thisDayGroup.openTime.slice(0, 2),
                          openMinute: thisDayGroup.openTime.slice(2, 4),
                          closeHour: thisDayGroup.closeTime.slice(0, 2),
                          closeMinute: thisDayGroup.closeTime.slice(2, 4),
                          openDay: thisDayGroup.openDay,
                          closeDay: thisDayGroup.closeDay
                        }
                      ];
                    } else {
                      
                      self.openingSetting[mealType][i.toString()].hours.push({
                        // isOpen: true,
                        openTime: thisDayGroup.openTime,
                        closeTime: thisDayGroup.closeTime,
                        openHour:  thisDayGroup.openTime.slice(0, 2),
                        openMinute: thisDayGroup.openTime.slice(2, 4),
                        closeHour: thisDayGroup.closeTime.slice(0, 2),
                        closeMinute: thisDayGroup.closeTime.slice(2, 4),
                        openDay: thisDayGroup.openDay,
                        closeDay: thisDayGroup.closeDay
                      });
                      // console.log('aaaaaaa ' + JSON.stringify(
                      //   {
                      //   // isOpen: true,
                      //   openTime: thisDayGroup.openTime,
                      //   closeTime: thisDayGroup.closeTime,
                      //   openHour:  thisDayGroup.openTime.slice(0, 2),
                      //   openMinute: thisDayGroup.openTime.slice(2, 4),
                      //   closeHour: thisDayGroup.closeTime.slice(0, 2),
                      //   closeMinute: thisDayGroup.closeTime.slice(2, 4),
                      //   openDay: thisDayGroup.openDay,
                      //   closeDay: thisDayGroup.closeDay
                      // }
                      // ))
                    }
                  } else if (thisDayGroup.openDay !== thisDayGroup.closeDay) {
                    // 晚上做到凌晨，跨日
                    if (thisDayGroup.openTime === thisDayGroup.closeTime) {
                      // 進階設定設定全天候，代表設定只能有一個
                      //24hour

                      self.openingSetting[mealType][i.toString()].hours = [
                        {
                          openTime: "allOpen",
                          closeTime: thisDayGroup.closeTime,
                          openHour: '00',
                          openMinute: '00',
                          closeHour: '00',
                          closeMinute: '00',
                          openDay: thisDayGroup.openDay,
                          closeDay: thisDayGroup.closeDay
                        }
                      ];
                    } else {
                      self.openingSetting[mealType][i.toString()].hours.push({
                        // isOpen: true,
                        openTime: thisDayGroup.openTime,
                        closeTime: thisDayGroup.closeTime,
                        openHour:  thisDayGroup.openTime.slice(0, 2),
                        openMinute: thisDayGroup.openTime.slice(2, 4),
                        closeHour: thisDayGroup.closeTime.slice(0, 2),
                        closeMinute: thisDayGroup.closeTime.slice(2, 4),
                        openDay: thisDayGroup.openDay,
                        closeDay: thisDayGroup.closeDay
                      });
                    }
                  }
                }
              } else {
                // 預設
                this.openingSetting[mealType][i.toString()] = {
                  // isOpen: i > 3 ? true : false,
                  isOpen: true,
                  hours: [
                    {
                      openTime: "allOpen",
                      closeTime: "0000",
                      openHour: '00',
                      openMinute: '00',
                      closeHour: '00',
                      closeMinute: '00',
                      openDay: i,
                      closeDay: i + 1 > 7 ? 0 : i + 1
                    }
                  ]
                };
              }
            }
            console.log('the final old settings ' + JSON.stringify(self.openingSetting));
          }
          
          this.currentOpeningDigest = this.openingDigest;
          
          this.initNewOpening();
          return response.data;
        });
    },
    initTimeOptions: function() {
      //公休日相關
      this.timeOptions = [
        // {
        //   id: "allOpen",
        //   name: "24 小時"
        // }
      ];
      this.timeHours = [];
      for (let i = 0; i < 24; ++i) {
        let tmp = moment({ hour: i, minute: 0 });
        this.timeOptions.push({
          id: tmp.format("HHmm"),
          name: tmp.format("HH:mm")
        });
        let tmp2 = moment({ hour: i, minute: 30 });
        this.timeOptions.push({
          id: tmp2.format("HHmm"),
          name: tmp2.format("HH:mm")
        });

        let key = i.toString().padStart(2, "0");
        this.timeHours.push({
          id: key, 
          name: key
        });
      }

      
      this.timeMinutes = [];
      for (let i = 0; i < 60; ++i) {
        let key = i.toString().padStart(2, "0");
        this.timeMinutes.push({
          id: key, 
          name: key
        });
      }

      // console.log('thie time ' + JSON.stringify(this.timeHours));

    },
    getSpecialOpenings() {
      //公休日相關
      // 特殊營業日
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.accountId
          }/opening-special`
        )
        .then(response => {
          // this.data = response.data;
          let renderData = [];
          for (let a of response.data) {
            renderData.push({
              id: a.id,
              specialDate: a.specialDate
                ? moment(a.specialDate, "YYYY-MM-DD").format("MM/DD")
                : "",
              dayOfWeek: a.specialDate
                ? moment(a.specialDate, "YYYY-MM-DD")
                    .locale("zh-tw")
                    .format("ddd")
                : "",
              openingPeriod:
                !a.openTime && a.closeDay == 100
                  ? "公休"
                  : a.openTime + " - " + a.closeTime
            });
          }

          this.specialOpeningData = renderData;
          // console.log("the sp data " + JSON.stringify(this.specialOpeningData));

          return response.data;
        });
    },
    addSpecialDate() {
      // console.log('add special date ', this.specialDateInput);
      let self = this;
      // this.specialDateInputFailed = "";
      if (this.specialDateInput) {
        let formatInput = this.specialDateInput;
        // let formatInput = moment(
        //   this.specialDateInput.toISOString(),
        //   moment.ISO_8601
        // ).format("YYYY-MM-DD");
        return axios
          .post(
            `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.accountId
            }/opening-special`,
            {
              date: formatInput,
              closeDay: 100
            }
          )
          .then(function() {
            self.getSpecialOpenings();
            self.specialDateInput = "";
            self.$message({
              type: "success",
              message: `公休日新增成功！`
            });
          })
          .catch(function(e) {
            self.specialDateInputFailed = e.message;
            self.$message({
              type: "error",
              message: `商店：${self.accountId} ，公休日修改失敗！`
            });
          });
      }
    },
    deleteSpecialDate(id) {
      let self = this;
      return axios
        .delete(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.accountId
          }/opening-special/${id}`
        )
        .then(function() {
          self.getSpecialOpenings();
          self.$message({
            type: "success",
            message: `公休日刪除成功！`
          });
        })
        .catch(e => {
          self.$message({
            type: "error",
            message: `商店：${self.accountId} ，公休日修改失敗！`
          });
        });
    },
    deleteHour(dayId, index, hour) {
      if (this.openingSetting['general'][dayId].hours)
        this.openingSetting['general'][dayId].hours.splice(index, 1);

      if (
        !this.openingSetting['general'][dayId].hours ||
        !this.openingSetting['general'][dayId].hours.length
      ) {
        // 轉為整日公休
        this.openingSetting['general'][dayId].isOpen = false;
      }
    },
    addHour(dayId) {
      if (this.openingSetting['general'][dayId].hours) {
        let intDayId = parseInt(dayId, 10);
        this.openingSetting['general'][dayId].hours.push({
          openTime: "0000",
          closeTime: "0000",
          openDay: intDayId,
          closeDay: intDayId
        });
      }
    },
    windowClosing() {
      this.getSpecialOpenings();
    },
    openImportPage: function() {
      // let qs = encodeURI(`?shop=${this.$route.query.shop_id}`);
      // var newWindow = window.open(
      //   `${process.env.VUE_APP_MENU}/opening-upload${qs}`,
      //   "upload-opening-setting",
      //   "width=200,height=100"
      //   // "width=300,location=no,menubar=no"
      // );
      var newWindow = window.open(
        `${process.env.VUE_APP_MENU}/#/shops/import-opening/${this.accountId}`,
        "",
        "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=1000"
      );
      // for same origin
      // newWindow.onbeforeunload = this.windowClosing;

      let self = this;
      // for cross origin
      var timer = setInterval(function() {
        if (newWindow.closed) {
          clearInterval(timer);
          self.windowClosing();
        }
      }, 1000);
    },
    saveOpening: function(event) {
      let _this = this;
      let params = {
        'general': [],
        'togo': [],
        'delivery': []
      }
      // this.updateStatus = "updating";

      let handle = ['general'];
      for (let cus of this.customTimes) {
        if (!cus.useDefault) {
          handle.push(cus.key);
        }
      }

      for (let mealType of handle) {
        
        for (let day in _this.openingSetting[mealType]) {
          let dayObj = _this.openingSetting[mealType][day];
          let tmp = {};

          if (dayObj.isOpen === false) {
            // 非營業日，要注意前一天是幾點打烊?
            let checkDay =
              dayObj.hours[0].openDay - 1 < 0 ? 0 : dayObj.hours[0].openDay - 1;

            let previousDayCloseDay =
              _this.openingSetting[mealType][checkDay.toString()].hours[0].closeDay;
            let previousDayCloseTime =
              _this.openingSetting[mealType][checkDay.toString()].hours[0].closeTime;
            // tmp.openTime = dayObj.closeTime = dayObj.openTime =
            //   _this.openingSetting['general'][checkDay.toString()].closeTime || "0000";
            for (
              let j = 1;
              j < _this.openingSetting[mealType][checkDay.toString()].hours;
              ++j
            ) {
              if (
                previousDayCloseDay !==
                  _this.openingSetting[mealType][checkDay.toString()].hours[0].closeDay &&
                _this.openingSetting[mealType][checkDay.toString()].hours[0].closeDay !==
                  checkDay
              ) {
                previousDayCloseDay =
                  _this.openingSetting[mealType][checkDay.toString()].hours[0].closeDay;
                previousDayCloseTime =
                  _this.openingSetting[mealType][checkDay.toString()].hours[0].closeTime;
              } else {
                let comingClose = parseInt(
                  _this.openingSetting[mealType][checkDay.toString()].hours[0].closeTime,
                  10
                );
                let nowClose = parseInt(previousDayCloseTime, 10);
                if (comingClose > nowClose) {
                  previousDayCloseTime =
                    _this.openingSetting[mealType][checkDay.toString()].hours[0].closeTime;
                }
              }
            }
            tmp.openTime = tmp.closeTime = previousDayCloseTime;
            tmp.closeDay = tmp.openDay = dayObj.hours[0].openDay;
            params[mealType].push(tmp);
          } else {
            for (let hour of dayObj.hours) {
              tmp = {};
              tmp.openTime = hour.openTime;
              if (hour.openTime === "allOpen") {
                // dayObj.openTime = '0000';
                hour.closeTime = "0000";

                hour.closeDay = hour.openDay + 1 > 7 ? 0 : hour.openDay + 1;

                tmp.openTime = "0000";
              } else {
                if (parseInt(hour.closeTime, 10) > parseInt(hour.openTime, 10)) {
                  hour.closeDay = hour.openDay;
                } else {
                  hour.closeDay = hour.openDay + 1 > 7 ? 0 : hour.openDay + 1;
                }
              }
              tmp.openDay = hour.openDay;
              tmp.closeDay = hour.closeDay;
              tmp.closeTime = hour.closeTime;
              params[mealType].push(tmp);
            }
          }
        }
      }
      

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.accountId
          }/opening-hours`,
          params
        )
        .then(response => {
          // this.updateStatus = "success";
          this.$emit("saved-status", { value: this.value });
          this.$message({
            type: "success",
            message: `供餐時間修改成功！`
          });

          this.currentOpeningDigest = this.openingDigest;
          this.openingIsChanged = false;
          this.initOpeningSetting(); //  有這個會抓出整體最正確數值，但是分開存似乎就變成沒意義@@
          return response.data;
        })
        .catch(e => {
          console.log("error msg is ", e);
          // this.updateStatus = "error";
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法儲存營業時段！`
          });
        });
    },
    addOpening: function(mealType) {
      // 新版架構增加一個schedule
      this.newOpening[mealType].push({
        id: new Date().getTime(),
        status: "edit",
        openTime: "allOpen",
        closeTime: "0000",
        openHour: '00',
        openMinute: '00',
        closeHour: '00',
        closeMinute: '00',
        daysBitArray: [...this.daysBitArray],
        rollback: {
          status: "edit",
          openTime: "allOpen",
          closeTime: "0000",
          openHour: '00',
          openMinute: '00',
          closeHour: '00',
          closeMinute: '00',
          daysBitArray: [...this.daysBitArray]
        }
      });
    },
    initNewOpening: function() {
      // 把每天的設定拿出來比較，一樣的放一起
      
      let handle = ['general', 'togo', 'delivery'];
      for (let mealType of handle) {
        let openingSetting = this.openingSetting[mealType];
        let settings;

        let rangeDigest = {}; // 有同樣range設定的就把day放一起
        for (let d in openingSetting) {
          let dayInt = parseInt(d, 10);
          if (openingSetting[d].isOpen && openingSetting[d].hours) {
            for (let h of openingSetting[d].hours) {
              let tmp = {
                openTime: h.openTime,
                closeTime: h.closeTime
              };
              
              if (!rangeDigest[JSON.stringify(tmp)]) {
                rangeDigest[JSON.stringify(tmp)] = {
                  isOpen: openingSetting[d].isOpen,
                  openTime: h.openTime,
                  closeTime: h.closeTime,
                  openHour: h.openHour,
                  openMinute: h.openMinute,
                  closeHour: h.closeHour,
                  closeMinute: h.closeMinute,
                  daysBitArray: [
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Sun"),
                      id: "0",
                      openDay: 0,
                      closeDay: 1
                    }, // sunday
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Mon"),
                      id: "1",
                      openDay: 1,
                      closeDay: 2
                    },
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Tue"),
                      id: "2",
                      openDay: 2,
                      closeDay: 3
                    },
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Wed"),
                      id: "3",
                      openDay: 3,
                      closeDay: 4
                    },
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Thu"),
                      id: "4",
                      openDay: 4,
                      closeDay: 5
                    },
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Fri"),
                      id: "5",
                      openDay: 5,
                      closeDay: 6
                    },
                    {
                      status: false,
                      display: this.$t("AccountSettingTime.Sat"),
                      id: "6",
                      openDay: 6,
                      closeDay: 0
                    }
                  ],
                  rollback: {
                    isOpen: openingSetting[d].isOpen,
                    openTime: h.openTime,
                    closeTime: h.closeTime,
                    openHour: h.openHour,
                    openMinute: h.openMinute,
                    closeHour: h.closeHour,
                    closeMinute: h.closeMinute,
                    daysBitArray: [
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Sun"),
                        id: "0",
                        openDay: 0,
                        closeDay: 1
                      }, // sunday
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Mon"),
                        id: "1",
                        openDay: 1,
                        closeDay: 2
                      },
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Tue"),
                        id: "2",
                        openDay: 2,
                        closeDay: 3
                      },
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Wed"),
                        id: "3",
                        openDay: 3,
                        closeDay: 4
                      },
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Thu"),
                        id: "4",
                        openDay: 4,
                        closeDay: 5
                      },
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Fri"),
                        id: "5",
                        openDay: 5,
                        closeDay: 6
                      },
                      {
                        status: false,
                        display: this.$t("AccountSettingTime.Sat"),
                        id: "6",
                        openDay: 6,
                        closeDay: 0
                      }
                    ]
                  }
                };
              }

              rangeDigest[JSON.stringify(tmp)].daysBitArray[dayInt].status = true;
            }
          }
        }

        // group by digest

        this.newOpening[mealType] = [];
        for (let key in rangeDigest) {
          rangeDigest[key].id = new Date().getTime() + this.newOpening[mealType].length;
          this.newOpening[mealType].push(rangeDigest[key]);
        }
      }
      
      // this.newOpening['general'] = newOpening;

      // console.log("init new opening " + JSON.stringify(this.newOpening['general']));
    },
    toggleOpening: function(day) {
      day.status = !day.status;
      return;
    },
    // startEditNewOpen: function(schedule) {
    //   let tmp = schedule;
    //   tmp.status = 'edit';
    //   schedule = tmp;

    //   console.log('start edit ' + JSON.stringify(schedule));
    //   return ;
    // },
    updateMealTypeTimes: function(mealType, setting) {
      mealType.useDefault = setting;
    },
    startEditNewOpen: function(mealType, index) {
      let tmp = this.newOpening[mealType][index]; //不知道為啥不這樣寫，不會rerender
      tmp.status = "edit";
      this.newOpening[mealType].splice(index, 1);
      this.newOpening[mealType].splice(index, 0, tmp);
      return;
    },
    discardEdit: function(mealType, index) {
      // 要復原本來的設定
      let tmp = this.newOpening[mealType][index]; //不知道為啥不這樣寫，不會rerender
      tmp.status = "";
      this.newOpening[mealType].splice(index, 1);
      this.newOpening[mealType].splice(index, 0, tmp);
      return;
    },
    removeNewOpening: function(mealType, index) {
      this.newOpening[mealType].splice(index, 1);
      
      console.log('the new opening setting ' + JSON.stringify(this.newOpening));
      // 應該要進行儲存, 但是index已經移除了...@@
      this.saveNewOpening(mealType, false);
    },
    saveNewOpening: function(mealType, index) {
      // 把新版格式轉成舊版格式
      console.log(JSON.stringify(this.openingSetting[mealType]));
      console.log('mealtype is ' + mealType);
      let tmp;
      if (index !== false) {
        tmp = this.newOpening[mealType][index]; //不知道為啥不這樣寫，不會rerender
        tmp.status = "";
      }
        
      if (tmp) {
        this.newOpening[mealType].splice(index, 1);
        this.newOpening[mealType].splice(index, 0, tmp);
      }
        

      let tmpObj = {
        "0": {
          isOpen: false,
          hours: [
            { openDay: 0, closeDay: 0, openTime: "0000", closeTime: "0000" }
          ]
        },
        "1": {
          isOpen: false,
          hours: [
            { openDay: 1, closeDay: 1, openTime: "0000", closeTime: "0000" }
          ]
        },
        "2": {
          isOpen: false,
          hours: [
            { openDay: 2, closeDay: 2, openTime: "0000", closeTime: "0000" }
          ]
        },
        "3": {
          isOpen: false,
          hours: [
            { openDay: 3, closeDay: 3, openTime: "0000", closeTime: "0000" }
          ]
        },
        "4": {
          isOpen: false,
          hours: [
            { openDay: 4, closeDay: 4, openTime: "0000", closeTime: "0000" }
          ]
        },
        "5": {
          isOpen: false,
          hours: [
            { openDay: 5, closeDay: 5, openTime: "0000", closeTime: "0000" }
          ]
        },
        "6": {
          isOpen: false,
          hours: [
            { openDay: 6, closeDay: 6, openTime: "0000", closeTime: "0000" }
          ]
        }
      };
      // console.log("convert " + JSON.stringify(this.newOpening[mealType]));
      for (let s of this.newOpening[mealType]) {
        let setting = s;
        if (s.status === "edit") {
          setting = s.rollback;
        }
        // console.log("check setting " + JSON.stringify(setting));
        for (let d of setting.daysBitArray) {
          // console.log(
          //   "the d is " + JSON.stringify(d) + " for " + setting.openTime
          // );
          if (d.status) {
            // 代表此天要設定
            if (!tmpObj[d.id].isOpen) {
              tmpObj[d.id].isOpen = true;
              tmpObj[d.id].hours = [];
            }

            if (setting.openHour && setting.openMinute) {
              setting.openTime = setting.openHour + setting.openMinute;
            }
            if (setting.closeHour && setting.closeMinute) {
              setting.closeTime = setting.closeHour + setting.closeMinute;
            }
            tmpObj[d.id].hours.push({
              openTime: setting.openTime,
              closeTime: setting.closeTime,
              openDay: d.openDay,
              closeDay: d.closeDay
            });
          }
        }
      }
      this.openingSetting[mealType] = tmpObj;
      console.log(JSON.stringify(this.openingSetting[mealType]));
      this.saveOpening();

      // 把edit跟rollback復原
      for (let s of this.newOpening[mealType]) {
        if (s.status !== "edit") {
          s.rollback = {
            isOpen: s.isOpen,
            openTime: s.openTime,
            closeTime: s.closeTime,
            daysBitArray: s.daysBitArray
          };
        }
      }
    }
  },
  watch: {
    openingDigest: function(newVal, oldVal) {
      console.log("openingDigest newVal: ", newVal);

      if (this.currentOpeningDigest !== newVal) {
        // 會在外層顯示驚嘆號
        this.$emit("edit-status", { value: this.value });
        this.openingIsChanged = true;
      }
    },
    newOpening: function() {
      console.log("update new opening");
    },
    editList: function(newVal, oldVal) {
      console.log("editList newVal: ", newVal);
      if (newVal.length > 0) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    },
    orderLimitEditMode: function(newVal, oldVal) {
      console.log("orderLimitEditMode: ", newVal, oldVal);
      var event;
      if (newVal) {
        event = {
          code: "order_limits",
          warning: true
        };
      } else {
        event = {
          code: "order_limits",
          warning: false
        };
      }
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
